import React, { useEffect, useState, useRef } from 'react';
import styles from './activitySkeleton.module.scss';
import NoBanner from '../../static/images_doctor/no_banner.png';
function ActivitySkeleton(props: any) {

    useEffect(() => {
        return () => {
        }
    }, [])

    return (
        <div className={`${styles.homeBanner_content}`}>
            <img src={NoBanner} alt="" />
        </div>
    )

}

export default ActivitySkeleton;